import {
    FIELD_TYPE_CAREER,
    FIELD_TYPE_ADDITIONAL_PHONE,
    FIELD_TYPE_PERSONAL_DATA,
    FIELD_TYPE_RECENT_JOBS,
    FIELD_TYPE_SKILLS,
    SYSTEM_TYPES,
} from "@/domains/profile/constants/system-types";

const formatters = {
    [FIELD_TYPE_CAREER]: {
        getDictionaries(fieldData, fieldValue) {
            const { career } = fieldData;

            if (!career.schedule.saveCustom) return null;

            const { schedule } = fieldValue.value || {};

            if (!schedule) return null;
            if (!schedule.custom) return null;
            const { dictionaryCodes } = SYSTEM_TYPES[FIELD_TYPE_CAREER];
            return [
                {
                    code: dictionaryCodes.schedule,
                    items: [schedule.text],
                },
            ];
        },

        updateDictionaries(fieldData, fieldValue, dictionaries) {
            const { dictionaryCodes } = SYSTEM_TYPES[FIELD_TYPE_CAREER];
            const code = dictionaryCodes.schedule;

            const { value } = fieldValue;

            const fieldDictionary = dictionaries[code];
            if (!fieldDictionary) return fieldValue;

            const { schedule, ...otherFields } = value;
            if (!schedule || !schedule.custom) return fieldValue;

            const itemId = fieldDictionary[schedule.text];

            return {
                value: {
                    ...otherFields,
                    schedule: {
                        id: itemId,
                        text: schedule.text,
                    },
                },
            };
        },
    },
    [FIELD_TYPE_ADDITIONAL_PHONE]: {
        getDictionaries(fieldData, fieldValue) {
            if (!fieldData.saveCustom) return null;

            const { status } = fieldValue.value || {};

            if (!status) return null;
            if (!status.custom) return null;
            const { dictionaryCode } = SYSTEM_TYPES[FIELD_TYPE_ADDITIONAL_PHONE];
            return [
                {
                    code: dictionaryCode,
                    items: [status.text],
                },
            ];
        },

        updateDictionaries(fieldData, fieldValue, dictionaries) {
            const code = SYSTEM_TYPES[FIELD_TYPE_ADDITIONAL_PHONE].dictionaryCode;
            const fieldDictionary = dictionaries[code];

            const { value } = fieldValue;
            if (!fieldDictionary) return fieldValue;

            const { status, ...otherFields } = value;
            if (!status || !status.custom) return fieldValue;

            const itemId = fieldDictionary[status.text];

            return {
                value: {
                    ...otherFields,
                    status: {
                        id: itemId,
                        text: status.text,
                    },
                },
            };
        },
    },
    [FIELD_TYPE_PERSONAL_DATA]: {
        getDictionaries(fieldData, fieldValue) {
            const { personalData } = fieldData;

            if (!personalData.familyStatus.saveCustom) return null;

            const { familyStatus } = fieldValue.value || {};

            if (!familyStatus) return null;
            if (!familyStatus.custom) return null;
            const { dictionaryCodes } = SYSTEM_TYPES[FIELD_TYPE_PERSONAL_DATA];
            return [
                {
                    code: dictionaryCodes.familyStatuses,
                    items: [familyStatus.text],
                },
            ];
        },

        updateDictionaries(fieldData, fieldValue, dictionaries) {
            const { dictionaryCodes } = SYSTEM_TYPES[FIELD_TYPE_PERSONAL_DATA];
            const code = dictionaryCodes.familyStatuses;

            const { value } = fieldValue;

            const fieldDictionary = dictionaries[code];
            if (!fieldDictionary) return fieldValue;

            const { familyStatus, ...otherFields } = value;
            if (!familyStatus || !familyStatus.custom) return fieldValue;

            const itemId = fieldDictionary[familyStatus.text];

            return {
                value: {
                    ...otherFields,
                    familyStatus: {
                        id: itemId,
                        text: familyStatus.text,
                    },
                },
            };
        },
    },
    [FIELD_TYPE_RECENT_JOBS]: {
        getDictionaries(fieldData, fieldValue) {
            if (!fieldData.saveCustom) return null;

            const { jobs } = fieldValue.value || [];

            if (!jobs || !jobs.length) return null;

            const customPositions = jobs.map((job) => job.position).filter((position) => position.custom);

            console.log({ customPositions });

            if (!customPositions.length) return null;

            const { dictionaryCode } = SYSTEM_TYPES[FIELD_TYPE_RECENT_JOBS];
            return [
                {
                    code: dictionaryCode,
                    items: customPositions.map((item) => item.text),
                },
            ];
        },

        updateDictionaries(fieldData, fieldValue, dictionaries) {
            const { dictionaryCode } = SYSTEM_TYPES[FIELD_TYPE_RECENT_JOBS];

            const { value } = fieldValue;

            const fieldDictionary = dictionaries[dictionaryCode];
            if (!fieldDictionary) return fieldValue;

            const { jobs, ...otherFields } = value;
            if (!jobs || !jobs.length) return fieldValue;

            const newJobs = jobs.map((job) => {
                const { position, ...jobFields } = job;
                if (!position.custom) return job;

                const itemId = fieldDictionary[position.text];
                return {
                    ...jobFields,
                    position: {
                        id: itemId,
                        text: position.text,
                    },
                };
            });

            return {
                value: {
                    ...otherFields,
                    jobs: newJobs,
                },
            };
        },
    },
    [FIELD_TYPE_SKILLS]: {
        getDictionaries(fieldData, fieldValue) {
            const { skills } = fieldData;
            const { program: programsConfig, language: languagesConfig } = skills;

            const { value } = fieldValue;
            const { programs: programsList = [], languages: languagesList = [] } = value;

            const { dictionaryCodes } = SYSTEM_TYPES[FIELD_TYPE_SKILLS];

            const dictionaries = [];

            console.log("SKILLS", { fieldData, fieldValue, dictionaryCodes });

            if (programsConfig.param.saveCustom) {
                const customPrograms = programsList.map((item) => item.value).filter((program) => program.custom);
                console.log({ customPrograms });
                if (customPrograms.length) {
                    const { programs: code } = dictionaryCodes;
                    dictionaries.push({
                        code,
                        items: customPrograms.map((item) => item.text),
                    });
                }
            }

            if (programsConfig.level.saveCustom) {
                const customProgramLevels = programsList.map((item) => item.level).filter((level) => level.custom);
                console.log({ customProgramLevels });
                if (customProgramLevels.length) {
                    const { programLevels: code } = dictionaryCodes;
                    dictionaries.push({
                        code,
                        items: customProgramLevels.map((item) => item.text),
                    });
                }
            }

            if (languagesConfig.param.saveCustom) {
                const customLanguages = languagesList.map((item) => item.value).filter((lang) => lang.custom);
                console.log({ customLanguages });
                if (customLanguages.length) {
                    const { languages: code } = dictionaryCodes;
                    dictionaries.push({
                        code,
                        items: customLanguages.map((item) => item.text),
                    });
                }
            }

            if (languagesConfig.level.saveCustom) {
                const customLanguageLevels = languagesList.map((item) => item.level).filter((level) => level.custom);
                console.log({ customLanguageLevels });
                if (customLanguageLevels.length) {
                    const { languageLevels: code } = dictionaryCodes;
                    dictionaries.push({
                        code,
                        items: customLanguageLevels.map((item) => item.text),
                    });
                }
            }

            if (!dictionaries.length) return null;

            console.log({ dictionaries });

            return dictionaries;
        },

        updateDictionaries(fieldData, fieldValue, dictionaries) {
            const { dictionaryCodes } = SYSTEM_TYPES[FIELD_TYPE_SKILLS];

            const { programs: programsList = [], languages: languagesList = [] } = fieldValue.value;

            console.log("update dict SKILLS", { dictionaryCodes, fieldValue, dictionaries });

            const programsDictionary = dictionaries[dictionaryCodes.programs];
            const programLevelsDictionary = dictionaries[dictionaryCodes.programLevels];
            const languagesDictionary = dictionaries[dictionaryCodes.languages];
            const languageLevelsDictionary = dictionaries[dictionaryCodes.languageLevels];

            const newPrograms = programsList.map((item) => {
                const { level, value } = item;
                const newItem = { level, value };
                if (value && value.custom) {
                    const itemId = programsDictionary ? programsDictionary[value.text] : value.id;
                    newItem.value = {
                        id: itemId,
                        text: value.text,
                    };
                }
                if (level && level.custom) {
                    const itemId = programLevelsDictionary ? programLevelsDictionary[level.text] : level.id;
                    newItem.level = {
                        id: itemId,
                        text: level.text,
                    };
                }
                return newItem;
            });

            const newLanguages = languagesList.map((item) => {
                const { level, value } = item;
                const newItem = { level, value };
                if (value && value.custom) {
                    const itemId = languagesDictionary ? languagesDictionary[value.text] : value.id;
                    newItem.value = {
                        id: itemId,
                        text: value.text,
                    };
                }
                if (level && level.custom) {
                    const itemId = languageLevelsDictionary ? languageLevelsDictionary[level.text] : level.id;
                    newItem.level = {
                        id: itemId,
                        text: level.text,
                    };
                }
                return newItem;
            });

            console.log({ newPrograms, newLanguages });

            return {
                value: {
                    programs: newPrograms,
                    languages: newLanguages,
                },
            };
        },
    },
};

export function getFieldUpdatedDictionaries(fieldData, fieldValue) {
    const { isSystem, fieldType, dictionaryCode, parentId, saveCustom } = fieldData;

    if (isSystem) {
        const formatter = formatters[fieldType];
        if (formatter && typeof formatter.getDictionaries === "function") {
            return formatter.getDictionaries(fieldData, fieldValue);
        }
    }

    if (!saveCustom) return null;

    const { customItems } = fieldValue;

    if (!customItems || !customItems.length) return null;

    return [
        {
            fieldId: parentId,
            code: dictionaryCode,
            items: fieldValue.customItems,
        },
    ];
}

export function getUpdatedDictionaries(fields, params) {
    let dictionaries = [];

    Object.values(fields).forEach((field) => {
        const { parentId } = field;
        const fieldValue = params[parentId];
        if (!fieldValue) return;

        const fieldDictionaries = getFieldUpdatedDictionaries(field, fieldValue);
        if (fieldDictionaries) dictionaries = [...dictionaries, ...fieldDictionaries];
    });

    console.log("get dictionaries", { params, fields, dictionaries });

    return dictionaries;
}

export function updateDictionaries(fieldData, fieldValue, dictionaries) {
    const { items, customItems, ...otherFields } = fieldValue;
    const { parentId, dictionaryCode } = fieldData;

    const fieldValueParams = {
        ...otherFields,
    };

    if (items || customItems) {
        const fieldItems = [...(items || [])];
        let fieldCustomItems = [];

        if (customItems) {
            const fieldDictionary = dictionaries[dictionaryCode || parentId];
            if (fieldDictionary) {
                customItems.forEach((item) => {
                    const itemId = fieldDictionary[item];
                    if (itemId) fieldItems.push(itemId);
                });
            } else {
                fieldCustomItems = customItems;
            }
        }

        if (fieldItems.length) fieldValueParams.value = fieldItems;
        if (fieldCustomItems.length) fieldValueParams.own_value = fieldCustomItems;
    }

    return fieldValueParams;
}

export function formatFieldParams(fieldData, fieldValue, dictionaries) {
    let fieldValueParams = {};

    const { isSystem, fieldType } = fieldData;
    const { files, oldFiles, ...valuesWithoutFiles } = fieldValue;

    if (oldFiles) {
        fieldValueParams.oldFiles = oldFiles.map((file) => file.id);
    }

    let updater = updateDictionaries;

    if (isSystem && formatters[fieldType]) {
        if (typeof formatters[fieldType].updateDictionaries === "function")
            updater = formatters[fieldType].updateDictionaries;
    }

    fieldValueParams = {
        ...fieldValueParams,
        ...updater(fieldData, valuesWithoutFiles, dictionaries),
    };

    return {
        value: fieldValueParams,
        files,
    };
}

export function formatParams(fields, params, dictionaries) {
    const values = [];
    const files = {};

    Object.values(fields).forEach((field) => {
        const { parentId } = field;
        const fieldValue = params[parentId];
        const { value: formattedFieldValue, files: fieldFiles } = formatFieldParams(field, fieldValue, dictionaries);

        if (fieldFiles) {
            files[parentId] = fieldFiles;
        }

        values.push({
            profile_field_id: parentId,
            ...formattedFieldValue,
        });
    });

    return {
        values,
        files,
    };
}
